import { useEffect, useRef, useState } from 'react'
import { InfoCard2 } from '../../../widgets/components/UI/InfoCard2'
import { useIntl } from 'react-intl'
import { DisplayImage } from '../../../widgets/components/General/DisplayImage'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { Form, Formik } from 'formik'
import TextInput from '../../../widgets/components/Input/TextInput'
import { SelectInput } from '../../../widgets/components/Input/SelectInput'
import { ToolTipUIForModal } from '../../../widgets/components/UI/ToolTipUIForModal'
import deleteicon from '../../../../../media/stakeholders/ic-delete.svg'
import SelectHeaderDropDown from '../../../widgets/components/Input/SelectInputDropDown'
import SelectSearchInput from '../../../widgets/components/Input/SelectSearchInput'
import { useGetAllDropdownData } from '../../../../hooks/useGetAllDropdownData'
import {
  managementTeamSidebarFields,
  ShareholdersTypes,
} from '../../stakeholders-and-investors/core/_constants'
// import { InputWithPhone } from '../../../widgets/components/Input/InputPhone'
import * as Yup from 'yup'
import { FileUpload } from '../../../widgets/components/FileUpload'
import { InputWithPhone } from '../../../widgets/components/Input/InputPhone'
import { getFileType } from '../../../../core/_util'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import { toast } from 'react-toastify'
import { useAuth } from '../../../auth'
import {
  createFinanceAccounts,
  getFinanceAccountsDetails,
  updateFinanceAcccounts,
} from '../core/_requests'
import { useFetchIndividualStakeholders } from '../../../../hooks/useFetchIndividualStakeholders'
import UserSearchTextInput from '../../components/user-search-text-input'
import { allowedFileTypes } from '../../../../core/_constants'
import moment from 'moment'
import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js'
import { DeleteFileConfirmationModal } from '../../components/delete-file-confirmation-modal'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../hooks/gtmHelpers'
import brandingConfig from '../../../../../config/brandingConfig'

export const AddIndividualFinanceAccountsForm = () => {
  const { companyId, currentUser } = useAuth()
  const { formatMessage } = useIntl()
  const [imgName, setImgName] = useState<string>('')
  const [modelStatus, setModelStatus] = useState<boolean>(false)
  const [sidebar, setSidebar] = useState(1)
  const [isLoading, setLoading] = useState<boolean>(false)
  const [financeAccountsDetails, setFinanceAccountsDetails] = useState<any>(null)
  const [isNotInitialized, setIsNotInitiaized] = useState(true)
  const [searchParams] = useSearchParams()
  const [individualStakeholders, setIndividualStakeholders] = useState<any>(null)
  const financeAccountsId = searchParams.get('financeAccountsId')
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [deleteFileId, setDeleteFileId] = useState<any>(null)
  const tab = searchParams.get('tab')
  const edit = searchParams.get('edit')?.toString() || ' '
  const [clearFormDataShowModal, setClearFormDataShowModal] = useState(false)
  const [clearFormDataLoading, setClearFormDataLoading] = useState(false)
  const formikRef = useRef<any>(null)
  const fileRef = useRef<any>([])
  const sidebarOptions = [
    { title: formatMessage({ id: 'Personal Details' }) },
    { title: formatMessage({ id: 'Address' }) },
    { title: formatMessage({ id: 'Other Details' }) },
    { title: formatMessage({ id: 'Documents' }) },
  ]

  const [files, setFiles] = useState<any>([])
  const [fetchFinanceAccountsLoading, setFetchFinanceAccountsLoading] = useState<boolean>(false)
  const {
    countryOptions,
    stateOptions,
    setCountryId,
    govtIdOptions,
    phoneCodesOptions,
    stateDataLoading,
  } = useGetAllDropdownData(ShareholdersTypes.INDIVIDUAL, formikRef)

  const {
    resetFields,
    onClickBlurText,
    onClickFocusText,
    openUserDropdown,
    setOpenUserDropdown,
    dropdownDataLoading,
    dropDownData,
    setNewEntryButtonClicked,
    fetchIndividualStakeholders,
    stakeHoldersDataLoading,
    fieldClicked,
  } = useFetchIndividualStakeholders(setIndividualStakeholders, setImgName, setCountryId)

  const handleClearFormData = () => {
    setClearFormDataLoading(true)
    if (formikRef.current) {
      formikRef.current.resetForm()
      setIndividualStakeholders(null)
    }
    setClearFormDataShowModal(false)
    setClearFormDataLoading(false)
  }

  useEffect(() => {
    if (!financeAccountsId || !companyId || !tab) return
    const fetchFinanceAccounts = async () => {
      setFetchFinanceAccountsLoading(true)
      try {
        const {
          data: { data, success },
        } = await getFinanceAccountsDetails(financeAccountsId, companyId)
        if (success) {
          setFinanceAccountsDetails(data)
          setImgName(data?.individual?.profileImage?.name)
          setCountryId(data?.individual?.country?.id)
        }
      } catch (error) {
        console.error('Error fetching countries:', error)
      } finally {
        setFetchFinanceAccountsLoading(false)
      }
    }
    fetchFinanceAccounts()
  }, [financeAccountsId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleClose = () => {
    setModelStatus(false)
  }
  const navigate = useNavigate()

  const deleteFile = () => {
    if (!deleteFileId) return
    setDeleteLoading(true)
    setFiles(files.filter((file: any) => file.id !== deleteFileId))
    if (formikRef.current) {
      formikRef.current.setFieldValue(
        'fileIds',
        files.filter((file: any) => file.id !== deleteFileId).map((file: any) => file.id)
      )
    }
    setDeleteLoading(false)
    setDeleteShowModal(false)
    toast.success('Document deleted successfully')
  }

  const userSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(1, 'First name must be at least 2 characters')
      .max(50, 'First name must be 50 characters or less')
      .nullable()
      .required('First name is required'),

    lastName: Yup.string()
      .min(1, 'Last name must be at least 2 characters')
      .max(50, 'Last name must be 50 characters or less')
      .nullable()
      .required('Last name is required'),

    email: Yup.string().email('Invalid email address').nullable().required('Email is required'),
    website: Yup.string().url('Invalid url').nullable(),
    nationality: Yup.object()
      .nullable()
      .test('required', 'Nationality is required', function (value: any, ctx) {
        if ((ctx.parent.sidebar === 3 || ctx.parent.sidebar === 4) && (!value || value === '')) {
          return false
        }
        return true
      }),
    address1: Yup.string()
      .nullable()
      .test('maxLength', 'Address 1 cannot be more than 300 characters', function (value) {
        if (!value || value?.length === 0) return true
        return !!(value && value.length <= 300)
      }),

    address2: Yup.string()
      .nullable()
      .test('maxLength', 'Address 2 cannot be more than 300 characters', function (value) {
        if (!value || value?.length === 0) return true
        return !!(value && value.length <= 300)
      }),
    dateOfBirth: Yup.date()
      .nullable()
      .test(
        'is-over-18',
        'Finance & Accounts member must be at least 18 years old',
        function (value) {
          if (!value) return true // Allow null/undefined values
          return moment().diff(moment(value), 'years') >= 18
        }
      ),
    phone: Yup.string()
      .nullable()
      .test('phone-number-valid', 'Invalid phone number', function (value, ctx: any) {
        if (!value || value === '') return true

        const selectedPhoneCode = ctx.parent.phoneCode
        const selectedCountryCode = phoneCodesOptions.find(
          (option: any) => option.dial_code === selectedPhoneCode
        )?.code

        if (phoneCodesOptions.length === 0 && ctx.originalValue) {
          return true // Invalid phone code
        }

        try {
          const phoneNumber = String(ctx.originalValue)
          const parsedNumber = parsePhoneNumberFromString(phoneNumber, selectedCountryCode)

          return isValidPhoneNumber(parsedNumber?.number as string)
        } catch (error) {
          return false
        }
      }),
  })

  useEffect(() => {
    if (financeAccountsDetails?.documents.length > 0 && isNotInitialized) {
      setFiles(
        financeAccountsDetails?.documents.map(({ fileId, name }: { fileId: string; name: string }) => ({
          id: fileId,
          name,
        }))
      )
    }
  }, [isNotInitialized, financeAccountsDetails?.documents])

  const initialValues = {
    sidebar: 1,
    profileImage: financeAccountsDetails?.individual?.profileImage?.id || '',
    firstName: financeAccountsDetails?.individual?.firstName || '',
    lastName: financeAccountsDetails?.individual?.lastName || '',
    email: financeAccountsDetails?.individual?.email || '',
    phoneCode: financeAccountsDetails?.individual?.phoneNumber
      ? financeAccountsDetails?.individual?.phoneNumber.split(' ')[0]
      : '+91',
    phone: financeAccountsDetails?.individual?.phoneNumber
      ? financeAccountsDetails?.individual?.phoneNumber.split(' ')[1]
      : '',
    gender: financeAccountsDetails?.individual?.gender || 'Male',
    dateOfBirth: financeAccountsDetails?.individual?.dateOfBirth || '',
    address1: financeAccountsDetails?.individual?.address1 || '',
    address2: financeAccountsDetails?.individual?.address2 || '',
    country: financeAccountsDetails?.individual?.country || '',
    state: financeAccountsDetails?.individual?.state || '',
    city: financeAccountsDetails?.individual?.city || '',
    zipCode: financeAccountsDetails?.individual?.zipCode || '',
    designation: financeAccountsDetails?.designation || '',
    nationality: financeAccountsDetails?.individual?.nationality || '',
    govtIssuedIdType: financeAccountsDetails?.individual?.govtIssuedIdType || '',
    govtIssuedIdNumber: financeAccountsDetails?.individual?.govtIssuedIdNumber || '',
    website: financeAccountsDetails?.individual?.website || '',
    education: financeAccountsDetails?.individual?.education || '',
    fileIds: financeAccountsDetails?.documents?.map((document: any) => document.fileId) || [],
  }

  const handleSubmit = async (values: any, { resetForm }: any) => {
    const rawPayload = {
      entityType: ShareholdersTypes.INDIVIDUAL,
      firstName: values?.firstName,
      lastName: values?.lastName,
      email: values?.email,
      gender: values?.gender,
      dateOfBirth: values?.dateOfBirth,
      address1: values?.address1,
      address2: values?.address2,
      city: values?.city,
      country: values?.country?.value || values?.country?.id,
      state: values?.state ? parseInt(values?.state?.id) || parseInt(values?.state?.value) : null,
      zipCode: values?.zipCode,
      nationality: values?.nationality?.value || values?.nationality?.id,
      profileImage: values.profileImage,
      website: values?.website,
      phoneCode: values?.phoneCode,
      phoneNumber: values?.phone,
      govtIssuedIdType: values?.govtIssuedIdType?.value,
      govtIssuedIdNumber: values?.govtIssuedIdNumber,
      education: values?.education,
      designation: values?.designation,
      fileIds: values?.fileIds,
      individualId: individualStakeholders ? individualStakeholders?.individualId : null,
      isEditPopulatedData: individualStakeholders ? true : null,
    }

    const payload = Object.fromEntries(
      Object.entries(rawPayload).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    )
    try {
      if (!companyId) {
        return
      }
      setLoading(true)
      if (financeAccountsDetails && financeAccountsId) {
        const {
          data: { success, errors },
        } = await updateFinanceAcccounts(payload, companyId, financeAccountsId)

        if (success) {
          resetForm()
          setImgName('')
          setFiles([])
          setFinanceAccountsDetails(null)
          navigate('/stakeholders/finance-and-accounts')
          setLoading(false)
          toast.success(formatMessage({ id: 'Finance and Accounts  updated successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateFinanceAccountsSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                finance_accounts: payload,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateFinanceAccountsFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                finance_accounts: payload,
                error: errors[0],
              },
            },
          })
        }
      } else {
        const {
          data: { success, errors },
        } = await createFinanceAccounts(payload, companyId)

        if (success) {
          toast.success(formatMessage({ id: 'Finance and Accounts added successfully' }))
          resetForm()
          setImgName('')
          setFiles([])
          setLoading(false)
          navigate('/stakeholders/finance-and-accounts')
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddFinanceAccountsSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                finance_accounts: payload,
              },
            },
          })
        } else {
          toast.error(errors[0])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.AddFinanceAccountsFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                finance_accounts: payload,
                error: errors[0],
              },
            },
          })
        }
      }
    } catch (err) {
      console.error('Error:', err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.AddFinanceAccountsFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            finance_accounts: payload,
            error: err,
          },
        },
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className='d-flex flex-md-row flex-column'>
        <div className='sidebar-investor-db col-md-1 d-none d-md-flex'>
          {sidebarOptions.map((sideTabs, index) => (
            <ul
              key={index}
              className='text-muted text-active-primary d-md-flex flex-column d-none align-items-left p-0 m-0 cursor-pointer'
            >
              <li
                className={`nav-link text-active-primary py-3 ps-3 d-flex align-items-center ${sidebar === index + 1
                  ? 'border-top-0 border border-bottom-0 border-right-0 border-left-3 border-primary text-primary border-5'
                  : ''
                  }`}
                onClick={() => {
                  setSidebar(index + 1)
                  if (formikRef.current) formikRef.current.setFieldValue('sidebar', index + 1)
                }}
              >
                {formatMessage({ id: sideTabs.title })}
              </li>
            </ul>
          ))}
        </div>
        <div className='mb-2 sidebar-investor-db col-md-1 d-flex d-md-none' style={{ width: '100%' }}>
          <div
            className='d-md-none d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {sidebarOptions.map((sideTabs: any, index: number) => (
              <>
                <ul
                  className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent mt-0 flex-nowrap mobile-tab-both my-md-0 mb-2 d-md-none'
                  style={{ display: 'flex', flexWrap: 'nowrap' }}
                >
                  <div>
                    <li
                      key={index}
                      className={
                        `nav-link text-active-primary py-3 ps-3 d-flex align-items-center` +
                        (sidebar === index + 1
                          ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                          : '')
                      }
                      onClick={() => setSidebar(index + 1)}
                    >
                      {formatMessage({ id: sideTabs.title })}
                    </li>
                  </div>
                </ul>
              </>
            ))}
          </div>
        </div>

        <div className='rounded-2 bg-white p-8 w-100'>
          <Formik
            initialValues={initialValues}
            validationSchema={userSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
            innerRef={formikRef}
            validateOnMount
            validateOnChange
          >
            {(formik: any) => {
              setCountryId(formik?.values?.country?.value)
              return (
                <Form>
                  {sidebar === 1 && (
                    <div className='hide-scrollbar' style={{ height: '100vh', overflowY: 'auto' }}>
                      <div className=''>
                        <InfoCard2
                          className='w-100'
                          title={formatMessage({ id: 'How to Add Finance & Accounts Team Members?' })}
                          desc={formatMessage({
                            id: `Add personal details, address information, and important documents for Finance & Accounts team members on ${brandingConfig.brandName}. Providing these details ensures accurate records and supports effective financial management and operations.`,
                          })}
                          slug={brandingConfig.helpLinks.addFinanceAccountsDetailsIndividual}
                        />
                      </div>
                      <div className='mb-4'>
                        <h2 className='font-size-16'>{formatMessage({ id: 'Personal Details' })}</h2>
                        <div>
                          <div className='d-flex form-label  text-dark font-size-13 mt-8'>
                            {formatMessage({ id: 'Profile Pic/Logo' })}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'Add/upload profile picture of the member from the Finance & Accounts team or the logo of the company that they represent.',
                              })}
                            />
                          </div>
                          <div className='card position-relative d-inline-flex justify-content-center '>
                            {fetchFinanceAccountsLoading || stakeHoldersDataLoading ? (
                              <Skeleton
                                height={120}
                                width={120}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            ) : (
                              <DisplayImage
                                imgName={imgName}
                                height='120px'
                                width='120px'
                                fit='contain'
                                alt='profile'
                                className='rounded'
                              />
                            )}
                            <FileUpload
                              fileSize={2097152}
                              maxFileNumber={1}
                              allowType={['image/*', '.jpg', '.jpeg', '.png']}
                              metaData={{ module: 'profileimg', isProtected: false }}
                              modalStatus={modelStatus}
                              handleClose={handleClose}
                              handleSuccess={(id: number, name: string) => {
                                setImgName(name)
                                formik.setFieldValue('profileImage', id)
                              }}
                              resourceType='all'
                            />

                            <div className='position-absolute' style={{ top: 0, right: 0 }}>
                              <img
                                onClick={() => setModelStatus(true)}
                                src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')}
                                alt=''
                              />
                            </div>
                          </div>
                          <p className='font-size-12 text-muted' style={{ maxWidth: '120px' }}>
                            {formatMessage({ id: 'Max size 2mb, supported format jpg, png' })}
                          </p>
                        </div>

                        {fetchFinanceAccountsLoading || stakeHoldersDataLoading ? (
                          <div className='col-xl-12 d-md-flex'>
                            <div>
                              <div
                                className={`card position-relative d-flex justify-content-center`}
                              >
                                <Skeleton
                                  height={130}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />{' '}
                              </div>
                            </div>
                            <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className='w-100 mt-10'>
                            <div className='row'>
                              <div className='col-md-6 col-12'>
                                <UserSearchTextInput
                                  label={formatMessage({ id: 'First Name' })}
                                  fieldName='firstName'
                                  toolTipText={formatMessage({
                                    id: 'Add first name of the Finance & Accounts team here.',
                                  })}
                                  dropdownData={dropDownData}
                                  dropdownDataLoading={dropdownDataLoading}
                                  openUserDropdown={openUserDropdown}
                                  onSelect={(id: string) => {
                                    setOpenUserDropdown(false)
                                    fetchIndividualStakeholders(id, formik)
                                  }}
                                  onNewEntryButtonClick={() => {
                                    setOpenUserDropdown(false)
                                    setIndividualStakeholders(null)
                                    setNewEntryButtonClicked(true)
                                  }}
                                  fieldClicked={fieldClicked}
                                  isDisabled={individualStakeholders?.firstName}
                                  setOpenUserDropdown={setOpenUserDropdown}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter First Name' })}
                                  onFocus={(e: any) =>
                                    onClickFocusText(e, formik, financeAccountsDetails)
                                  }
                                  ariaLabel='firstName'
                                  onBlur={(e: any) => onClickBlurText(e, formik)}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <UserSearchTextInput
                                  label={formatMessage({ id: 'Last Name' })}
                                  fieldName='lastName'
                                  toolTipText={formatMessage({
                                    id: 'Add last name of the Finance & Accounts team here.',
                                  })}
                                  dropdownData={dropDownData}
                                  dropdownDataLoading={dropdownDataLoading}
                                  openUserDropdown={openUserDropdown}
                                  onSelect={(id: string) => {
                                    setOpenUserDropdown(false)
                                    fetchIndividualStakeholders(id, formik)
                                  }}
                                  onNewEntryButtonClick={() => {
                                    setOpenUserDropdown(false)
                                    setIndividualStakeholders(null)
                                    setNewEntryButtonClicked(true)
                                  }}
                                  fieldClicked={fieldClicked}
                                  setOpenUserDropdown={setOpenUserDropdown}
                                  isDisabled={individualStakeholders?.lastName}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Last Name' })}
                                  onFocus={(e: any) =>
                                    onClickFocusText(e, formik, financeAccountsDetails)
                                  }
                                  ariaLabel='lastName'
                                  onBlur={(e: any) => onClickBlurText(e, formik)}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Email Id' })}
                                  fieldName='email'
                                  isDisabled={individualStakeholders?.email}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Email ID' })}
                                  toolTipText={formatMessage({
                                    id: 'Add email address of the member from the Finance & Accounts team.',
                                  })}
                                  isStarRequired={true}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <InputWithPhone
                                  fieldName='phone'
                                  selectOptionFieldName='phoneCode'
                                  label={formatMessage({ id: 'Phone' })}
                                  disabled={
                                    individualStakeholders?.phoneCode &&
                                    individualStakeholders?.phoneNumber
                                  }
                                  placeholder={formatMessage({ id: 'Enter Phone Number' })}
                                  placeholderSelect='+91'
                                  formik={formik}
                                  options={phoneCodesOptions}
                                  toolTipText={formatMessage({
                                    id: 'Select country code and add phone number of the member from the Finance & Accounts team.',
                                  })}
                                  isStarRequired={true}
                                  isTooltipForModal={true}
                                  onBlur={formik.handleBlur}
                                  onFocus={formik.handleFocus}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectInput
                                  label={formatMessage({ id: 'Gender' })}
                                  fieldName='gender'
                                  placeholder={formatMessage({
                                    id: 'Select Gender',
                                  })}
                                  disabled={individualStakeholders?.gender}
                                  formik={formik}
                                  toolTipText={formatMessage({
                                    id: 'Specify gender of the member from the Finance & Accounts team.',
                                  })}
                                  options={['Male', 'Female', 'Others']}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='date'
                                  label={formatMessage({ id: 'Date of birth' })}
                                  fieldName='dateOfBirth'
                                  isDisabled={individualStakeholders?.dateOfBirth}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Select Date of birth' })}
                                  toolTipText={formatMessage({
                                    id: 'Add date of birth of the member from the Finance & Accounts team.',
                                  })}
                                  isStarRequired={false}
                                  isDateOfBirth={true}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                            </div>

                            <div className='d-md-flex justify-content-end gap-2 mt-10'>
                              <div className='d-flex flex-reverse flex-column flex-md-row gap-2 gap-md-4 w-100'>
                                <div className='d-flex flex-row justify-content-between w-100'>
                                  <div>
                                    {!financeAccountsDetails && (
                                      <button
                                        type='button'
                                        onClick={() => {
                                          if (individualStakeholders) {
                                            setClearFormDataShowModal(true)
                                          } else {
                                            resetFields(formik, managementTeamSidebarFields)
                                          }
                                        }}
                                        disabled={
                                          !individualStakeholders &&
                                          Object.entries(formik.values)
                                            // Filter only those keys that exist in the current sidebar's fields
                                            .filter(([key]) =>
                                              managementTeamSidebarFields[
                                                formik.values.sidebar as 1 | 2 | 3
                                              ]?.includes(key)
                                            )
                                            .filter(
                                              ([key]) =>
                                                ![
                                                  'gender',
                                                  'phoneCode',
                                                  'workCompanyName',
                                                  'workIndustry',
                                                ].includes(key)
                                            )
                                            .every(
                                              ([_, value]) =>
                                                value === null ||
                                                value === '' ||
                                                (Array.isArray(value) && value.length === 0) // Handle empty arrays as empty
                                            )
                                        }
                                        className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1'
                                      >
                                        {formatMessage({
                                          id: individualStakeholders ? 'Clear All' : 'Clear',
                                        })}
                                      </button>
                                    )}
                                  </div>
                                  <div>
                                    <button
                                      className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1 me-4'
                                      onClick={() => {
                                        navigate('/stakeholders/finance-and-accounts')
                                      }}
                                    >
                                      {formatMessage({ id: 'Cancel' })}
                                    </button>
                                    <button
                                      type='button'
                                      onClick={() => {
                                        setSidebar(sidebar + 1)
                                        if (formikRef.current)
                                          formikRef.current.setFieldValue('sidebar', sidebar + 1)
                                      }}
                                      disabled={
                                        individualStakeholders
                                          ? false
                                          : edit === 'true'
                                            ? !formik.isValid
                                            : !formik.isValid || !formik.dirty
                                      }
                                      className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                                    >
                                      {formatMessage({ id: 'Next' })}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {sidebar === 2 && (
                    <div className='hide-scrollbar' style={{ height: '100vh', overflowY: 'auto' }}>
                      <div className='mb-4'>
                        <h2 className='font-size-16 mb-5'>
                          {formatMessage({ id: 'Official Address' })}
                        </h2>

                        <div className=''>
                          <InfoCard2
                            className='w-100'
                            title={formatMessage({
                              id: 'How to Add Finance & Accounts Team Members?',
                            })}
                            desc={formatMessage({
                              id: `Add personal details, address information, and important documents for Finance & Accounts team members on ${brandingConfig.brandName}. Providing these details ensures accurate records and supports effective financial management and operations.`,
                            })}
                            slug={brandingConfig.helpLinks.addFinanceAccountsDetailsIndividual}
                          />
                        </div>

                        {fetchFinanceAccountsLoading || stakeHoldersDataLoading ? (
                          <div className='col-xl-12 d-md-flex'>
                            <div>
                              <div
                                className={`card position-relative d-flex justify-content-center`}
                              >
                                <Skeleton
                                  height={130}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />{' '}
                              </div>
                            </div>
                            <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className='w-100 mt-10'>
                            <div className='row'>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Address Line 1' })}
                                  fieldName='address1'
                                  formik={formik}
                                  isDisabled={individualStakeholders?.address1}
                                  placeholder={formatMessage({ id: 'Enter Address Line 1' })}
                                  toolTipText={formatMessage({
                                    id: 'Add a correspondence address of the member from the Finance & Accounts team.',
                                  })}
                                  isStarRequired={false}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Address Line 2' })}
                                  fieldName='address2'
                                  isDisabled={individualStakeholders?.address2}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Address Line 2' })}
                                  toolTipText={formatMessage({
                                    id: 'Add a correspondence address of the member from the Finance & Accounts team.',
                                  })}
                                  isStarRequired={false}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectSearchInput
                                  label={formatMessage({ id: 'Country' })}
                                  fieldName='country'
                                  disabled={individualStakeholders?.country}
                                  placeholder={formatMessage({ id: 'Select Country' })}
                                  formik={formik}
                                  toolTipText={formatMessage({
                                    id: 'Add country of the member from the Finance & Accounts team where they reside.',
                                  })}
                                  options={countryOptions}
                                  isStarRequired
                                  onBlur={formik.handleBlur}
                                />
                              </div>

                              <div className='col-md-6 col-12'>
                                {stateDataLoading ? (
                                  <div className='col-md-5 mb-10 mb-md-0'>
                                    <div className='w-50'>
                                      <Skeleton
                                        height={20}
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                      />
                                    </div>
                                    <div className='mt-2'>
                                      <Skeleton
                                        height={30}
                                        baseColor='var(--kt-skeleton-bg-color)'
                                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <SelectSearchInput
                                    label={formatMessage({ id: 'State' })}
                                    fieldName='state'
                                    placeholder={formatMessage({ id: 'Select State' })}
                                    formik={formik}
                                    toolTipText={formatMessage({
                                      id: 'Specify the state where the  Finance & Accounts team resides',
                                    })}
                                    disabled={individualStakeholders?.state}
                                    options={stateOptions}
                                    isStarRequired={true}
                                  />
                                )}
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'City' })}
                                  fieldName='city'
                                  formik={formik}
                                  isDisabled={individualStakeholders?.city}
                                  placeholder={formatMessage({ id: 'Enter City' })}
                                  toolTipText={formatMessage({
                                    id: 'Add city of the  Finance & Accounts team here.',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='string'
                                  label={formatMessage({ id: 'Zipcode' })}
                                  fieldName='zipCode'
                                  formik={formik}
                                  isDisabled={individualStakeholders?.zipCode}
                                  placeholder={formatMessage({ id: 'Enter Zipcode' })}
                                  toolTipText={formatMessage({
                                    id: 'Add ZIP Code of the city of the member from the Finance & Accounts team where they reside.',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                            </div>

                            <div className='d-md-flex justify-content-end gap-2 mt-10'>
                              <div className='d-flex flex-reverse flex-column flex-md-row gap-2 gap-md-4 w-100'>
                                <div className='d-flex flex-row justify-content-between w-100'>
                                  <div>
                                    {!financeAccountsDetails && (
                                      <button
                                        type='button'
                                        onClick={() => {
                                          if (individualStakeholders) {
                                            setClearFormDataShowModal(true)
                                          } else {
                                            resetFields(formik, managementTeamSidebarFields)
                                          }
                                        }}
                                        disabled={
                                          !individualStakeholders &&
                                          Object.entries(formik.values)
                                            // Filter only those keys that exist in the current sidebar's fields
                                            .filter(([key]) =>
                                              managementTeamSidebarFields[
                                                formik.values.sidebar as 1 | 2 | 3
                                              ]?.includes(key)
                                            )
                                            .every(
                                              ([_, value]) =>
                                                value === null ||
                                                value === '' ||
                                                (Array.isArray(value) && value.length === 0) // Handle empty arrays as empty
                                            )
                                        }
                                        className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1'
                                      >
                                        {formatMessage({
                                          id: individualStakeholders ? 'Clear All' : 'Clear',
                                        })}
                                      </button>
                                    )}
                                  </div>
                                  <div>
                                    <button
                                      className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1 me-4'
                                      onClick={() => {
                                        setSidebar(sidebar - 1)
                                        if (formikRef.current) {
                                          formikRef.current.setFieldValue('sidebar', sidebar - 1)
                                        }
                                      }}
                                    >
                                      {formatMessage({ id: 'Back' })}
                                    </button>
                                    <button
                                      type='button'
                                      onClick={() => {
                                        setSidebar(sidebar + 1)
                                        if (formikRef.current)
                                          formikRef.current.setFieldValue('sidebar', sidebar + 1)
                                      }}
                                      disabled={
                                        individualStakeholders
                                          ? false
                                          : edit === 'true'
                                            ? !formik.isValid
                                            : !formik.isValid || !formik.dirty
                                      }
                                      className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                                    >
                                      {formatMessage({ id: 'Next' })}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {sidebar === 3 && (
                    <div className='hide-scrollbar' style={{ height: '100vh', overflowY: 'auto' }}>
                      <div className='mb-4'>
                        <h2 className='font-size-16 mb-5'>
                          {formatMessage({ id: 'Other Details' })}
                        </h2>

                        <div className=''>
                          <InfoCard2
                            className='w-100'
                            title={formatMessage({
                              id: 'How to Add Finance & Accounts Team Members?',
                            })}
                            desc={formatMessage({
                              id: `Add personal details, address information, and important documents for Finance & Accounts team members on ${brandingConfig.brandName}. Providing these details ensures accurate records and supports effective financial management and operations.`,
                            })}
                            slug={brandingConfig.helpLinks.addFinanceAccountsDetailsIndividual}
                          />
                        </div>

                        {fetchFinanceAccountsLoading || stakeHoldersDataLoading ? (
                          <div className='col-xl-12 d-md-flex'>
                            <div>
                              <div
                                className={`card position-relative d-flex justify-content-center`}
                              >
                                <Skeleton
                                  height={130}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />{' '}
                              </div>
                            </div>
                            <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                                <div className='col-md-5 mb-10 mb-md-0'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                                <div className='col-md-5'>
                                  <div className='w-50'>
                                    <Skeleton
                                      height={20}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                  <div className='mt-2'>
                                    <Skeleton
                                      height={30}
                                      baseColor='var(--kt-skeleton-bg-color)'
                                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className='w-100 mt-10'>
                            <div className='row'>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Designation' })}
                                  fieldName='designation'
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Designation' })}
                                  toolTipText={formatMessage({
                                    id: 'Designation refers to the specific position or role assigned to an employee within the company. It typically highlights the function or duties an employee is responsible for. For eg. CEO, Marketing Manager etc.',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectSearchInput
                                  label={formatMessage({ id: 'Nationality' })}
                                  fieldName='nationality'
                                  formik={formik}
                                  disabled={individualStakeholders?.nationality}
                                  placeholder={formatMessage({ id: 'Enter Nationality' })}
                                  toolTipText={formatMessage({
                                    id: 'Add nationality of the member from the Finance & Accounts team.',
                                  })}
                                  options={countryOptions}
                                  isStarRequired={false}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <SelectHeaderDropDown
                                  label={formatMessage({ id: 'Govt. issued ID type' })}
                                  toolTipText={formatMessage({
                                    id: 'Select govt. issued ID card for the member from the  Finance & Accounts team.',
                                  })}
                                  fieldName='govtIssuedIdType'
                                  disabled={individualStakeholders?.govtIssuedIdType}
                                  placeholder='Select Govt. issued ID type'
                                  formik={formik}
                                  isStarRequired
                                  dropdownOptions={govtIdOptions}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Govt. Issued ID Number' })}
                                  fieldName='govtIssuedIdNumber'
                                  formik={formik}
                                  placeholder={formatMessage({
                                    id: 'Enter Govt. Issued ID Number',
                                  })}
                                  isDisabled={individualStakeholders?.govtIssuedIdNumber}
                                  toolTipText={formatMessage({
                                    id: 'Enter number of the selected Govt. issued ID of the member from the Finance & Accounts team.',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Website' })}
                                  fieldName='website'
                                  formik={formik}
                                  isDisabled={individualStakeholders?.website}
                                  placeholder={formatMessage({ id: 'Enter Website url' })}
                                  toolTipText={formatMessage({
                                    id: 'Add a website address of the member from the Finance & Accounts team or of the company that they represent.',
                                  })}
                                  isStarRequired={false}
                                  onBlur={formik.handleBlur}
                                />
                              </div>
                              <div className='col-md-6 col-12'>
                                <TextInput
                                  fieldType='text'
                                  label={formatMessage({ id: 'Education' })}
                                  fieldName='education'
                                  isDisabled={individualStakeholders?.education}
                                  formik={formik}
                                  placeholder={formatMessage({ id: 'Enter Education' })}
                                  toolTipText={formatMessage({
                                    id: 'Add education of the member from the Finance & Accounts team or of the company that they represent.',
                                  })}
                                  isStarRequired={false}
                                />
                              </div>
                            </div>

                            <div className='d-md-flex justify-content-end gap-2 mt-10'>
                              <div className='d-flex flex-reverse flex-column flex-md-row gap-2 gap-md-4 w-100'>
                                <div className='d-flex flex-row justify-content-between w-100'>
                                  <div>
                                    {!financeAccountsDetails && (
                                      <button
                                        type='button'
                                        onClick={() => {
                                          if (individualStakeholders) {
                                            setClearFormDataShowModal(true)
                                          } else {
                                            resetFields(formik, managementTeamSidebarFields)
                                          }
                                        }}
                                        disabled={
                                          !individualStakeholders &&
                                          Object.entries(formik.values)
                                            // Filter only those keys that exist in the current sidebar's fields
                                            .filter(([key]) =>
                                              managementTeamSidebarFields[
                                                formik.values.sidebar as 1 | 2 | 3
                                              ]?.includes(key)
                                            )
                                            .every(
                                              ([_, value]) =>
                                                value === null ||
                                                value === '' ||
                                                (Array.isArray(value) && value.length === 0) // Handle empty arrays as empty
                                            )
                                        }
                                        className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1'
                                      >
                                        {formatMessage({
                                          id: individualStakeholders ? 'Clear All' : 'Clear',
                                        })}
                                      </button>
                                    )}
                                  </div>
                                  <div>
                                    <button
                                      className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1 me-4'
                                      onClick={() => {
                                        setSidebar(sidebar - 1)
                                        if (formikRef.current) {
                                          formikRef.current.setFieldValue('sidebar', sidebar - 1)
                                        }
                                      }}
                                    >
                                      {formatMessage({ id: 'Back' })}
                                    </button>
                                    <button
                                      type='button'
                                      onClick={() => {
                                        setSidebar(sidebar + 1)
                                        if (formikRef.current)
                                          formikRef.current.setFieldValue('sidebar', sidebar + 1)
                                      }}
                                      disabled={
                                        individualStakeholders
                                          ? false
                                          : edit === 'true'
                                            ? !formik.isValid
                                            : !formik.isValid || !formik.dirty
                                      }
                                      className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                                    >
                                      {formatMessage({ id: 'Next' })}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {sidebar === 4 && (
                    <>
                      <div className=''>
                        <h2 className='font-size-16 mb-5'>
                          {formatMessage({
                            id: 'Documents related to this finance and accounts member',
                          })}
                        </h2>
                        <div className=''>
                          <InfoCard2
                            className='w-100'
                            title={formatMessage({
                              id: 'How to Add Finance & Accounts Team Members?',
                            })}
                            desc={formatMessage({
                              id: `Add personal details, address information, and important documents for Finance & Accounts team members on ${brandingConfig.brandName}. Providing these details ensures accurate records and supports effective financial management and operations.`,
                            })}
                            slug={brandingConfig.helpLinks.addFinanceAccountsDetailsIndividual}
                          />
                        </div>
                        <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                          {formatMessage({ id: 'Attach files' })}{' '}
                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'Add/upload documents related to the member of the  finance & accounts team being added here.',
                            })}
                          />
                        </div>
                        <FileUpload
                          fileSize={parseInt(process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE!)}
                          maxFileNumber={10}
                          allowType={allowedFileTypes}
                          metaData={{ module: 'document', isProtected: false }}
                          modalStatus={modelStatus}
                          handleClose={handleClose}
                          handleSuccess={(id: number, name: string) => {
                            setIsNotInitiaized(false)

                            setFiles((prevFiles: any) => [...prevFiles, { id, name }])

                            if (formikRef.current) {
                              const currentFileIds = Array.isArray(
                                formikRef.current.values.fileIds
                              )
                                ? formikRef.current.values.fileIds
                                : []

                              fileRef.current.push(id) // Store only the current ID
                              const uniqueFileIds = Array.from(
                                new Set([...currentFileIds, ...fileRef.current])
                              )
                              formikRef.current.setFieldValue('fileIds', uniqueFileIds)
                            }
                          }}
                          resourceType='all'
                        />
                        <div className='w-100'>
                          <button
                            type='button'
                            className='btn bg-primary custom-button-property text-white border border-1 mb-4 px-6 py-4 text-center w-100 w-md-auto'
                            onClick={() => setModelStatus(true)}
                          >
                            {formatMessage({ id: 'Import Files' })}
                          </button>
                        </div>
                      </div>

                      <div className='mb-4'>
                        {files.length > 0 && (
                          <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                            {formatMessage({ id: 'Uploaded Files' })}{' '}
                            <ToolTipUIForModal
                              tooltipText={formatMessage({
                                id: 'Manage all the uploaded documents here.',
                              })}
                            />
                          </div>
                        )}

                        {fetchFinanceAccountsLoading ? (
                          <>
                            <div className='w-50'>
                              <Skeleton
                                width={'100%'}
                                height={48}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>
                            <div className='w-50'>
                              <Skeleton
                                width={'100%'}
                                height={48}
                                baseColor='var(--kt-skeleton-bg-color)'
                                highlightColor='var(--kt-skeleton-highlight-bg-color)'
                              />
                            </div>
                          </>
                        ) : (
                          <div className='w-100'>
                            <ul className='p-0 m-0'>
                              {files?.map((file: any) => (
                                <li
                                  key={file.id}
                                  className='d-flex align-items-center gap-2 text-decoration-none mb-3 w-100 border border-1 p-2'
                                >
                                  <div className='d-flex justify-content-between align-items-center w-100'>
                                    <div className='w-100 d-flex align-items-center gap-2'>
                                      <img
                                        src={getFileType(file.name)}
                                        alt={file.name}
                                        style={{ height: '30px', width: '30px' }}
                                      />

                                      <p className='p-0 m-0 max-file-width'>
                                        {file.name.split('/').pop()}
                                      </p>
                                    </div>

                                    <button
                                      type='button'
                                      className='btn btn-secondry p-0 m-0  d-flex align-items-start'
                                      onClick={() => {
                                        setDeleteFileId(file.id)
                                        setDeleteShowModal(true)
                                      }}
                                    >
                                      <img src={deleteicon} alt='Delete' />
                                    </button>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                        <div className='d-md-flex justify-content-end gap-2 mt-10'>
                          <div className='d-flex flex-reverse flex-column flex-md-row gap-2 gap-md-4'>
                            <button
                              className='btn bg-light custom-button-property border border-1 mb-md-4 mb-2 px-6 py-4 text-muted text-center w-100 w-md-auto order-2 order-md-1'
                              onClick={() => {
                                setSidebar(sidebar - 1)
                                if (formikRef.current) {
                                  formikRef.current.setFieldValue('sidebar', sidebar - 1)
                                }
                              }}
                            >
                              {formatMessage({ id: 'Back' })}
                            </button>
                            <button
                              className='btn bg-primary custom-button-property text-white border border-1 mb-md-4 mb-0 px-6 py-4 text-center w-100 w-md-auto order-1 order-md-2'
                              disabled={!formik.isValid || isLoading}
                            >
                              {!isLoading && (
                                <span className='indicator-label font-size-13 p-0'>
                                  {formatMessage({ id: 'Submit' })}
                                </span>
                              )}
                              {isLoading && (
                                <span className='indicator-label font-size-13 p-0'>
                                  {formatMessage({ id: 'Please wait...' })}
                                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                </span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
      <DeleteFileConfirmationModal
        setDeleteShowModal={setDeleteShowModal}
        showDeleteModal={showDeleteModal}
        onDeleteSubmit={deleteFile}
        deleteLoading={deleteLoading}
        header='Delete File'
        paragraph='Are you sure you want to delete this file?'
      />
      <DeleteFileConfirmationModal
        setDeleteShowModal={setClearFormDataShowModal}
        showDeleteModal={clearFormDataShowModal}
        onDeleteSubmit={handleClearFormData}
        deleteLoading={clearFormDataLoading}
        header='Clear Form Data In Steps'
        paragraph='Are you sure you want to clear all the form data across the steps (Personal Details, Address, Other Details)?'
      />
    </>
  )
}
